import React from 'react';
import PropTypes from 'prop-types';

import { formatDate, formatDateTime } from 'helpers/formatters/date_time_formats';

export default function DateWithHover({ timestamp }) {
  const dateDisplay = formatDate(timestamp);
  const dateTimeDisplay = formatDateTime(timestamp);

  return (
    <span title={dateTimeDisplay}>
      {dateDisplay}
    </span>
  );
}

DateWithHover.propTypes = {
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};
